import { Detail } from "./Detail";

export class LetterOfAuthorizationRequest {
    subAccountId: string = '';
    masterAccountId: string = '';
    toAccountId: string;
    transactionType: string = '';
    frequency: string;
    toDetails: Detail[] = [];
    submitDetails: Detail[] = [];
    createSloaDetails: Detail[] = [];
    messageDetails: string[] = [];
    selectedPositionsList: string[] = [];
    pdf: string = '';
    append: string[] = [];
    formsFlowPdf: boolean = false;
    isFromNoSigPdfFlow: boolean = false;
    isDeleteSloaPdf: boolean = false;
    isJournalsForms: boolean = false;
    isChecksForms: boolean = false;
    isJournalsGift: boolean = false;
    isJournalsI401K: boolean = false;
    transferId: string = '';
    processId: string = '';
    registrationType: string = '';
    state: string = '';
    checksIaInformationAccess?: ChecksIaInformationAccess;
    journalsIaInformationAccess?: JournalsIaInformationAccess;
    UseOneTimeDistSloa: boolean = false;
    UseOneTimeDistBsloa: boolean = false;

    public constructor(init?: Partial<LetterOfAuthorizationRequest>) {
        Object.assign(this, init);
    }
}

export interface ChecksIaInformationAccess {
    investmentCalendarYear: string;
    investmentCalendarMonth: string;
    investmentCalendarDate: string;
}

export interface JournalsIaInformationAccess {
    investmentCalendarYear: string;
    investmentCalendarMonth: string;
    investmentCalendarDate: string;
}
